export default __webpack_public_path__ + "static/media/team3.04f8c8e0.png";